import { ClosedSangjoProps } from "@/types/sangjoType";
import { VStack } from "goi_common";

interface Props {
  companyName: ClosedSangjoProps["companyname"];
  status: ClosedSangjoProps["status"];
}

const ParlorClosedGuideInformation = ({ companyName, status }: Props) => {
  return (
    <VStack as="section" gap="12px">
      <VStack gap="6px" className="body_14_m">
        <p className="body_14_m">
          {companyName}에 가입한 가입자는 다음 중 한 가지 방법을 통해 피해 보상을 받을 수 있습니다.
        </p>
        <br />
        <ul>
          <li>
            1. 납입 금액의 50% 수령
            <br />
            (예치계약, 보상보험, 공제계약 등 계약의 성격에 따라 보상금 청구 기한이 정해져 있는
            경우가 있어, 보상 기간에 대해서는 개별적인 확인이 반드시 필요합니다)
          </li>
          <br />
          <li>2. {"'내상조 그대로'"}에 참여한 상조 회사의 상조 서비스 이용</li>
        </ul>
        <br />
        <p>더 자세한 피해 보상 방법은 아래 가이드북에서 확인할 수 있습니다. </p>
      </VStack>
    </VStack>
  );
};

export default ParlorClosedGuideInformation;
